module.exports = __webpack_public_path__ + "img/violet_114.d26e505d.png";